import React, { useState, useEffect } from 'react';
import { User, Building2 } from 'lucide-react';
import { getUserLabelStats } from '../../../api/labels';

/**
 * ProfileInfo - 个人信息展示组件（卡片分组布局）
 */
export function ProfileInfo({ profileData, onUpgrade }) {
  const isEnterprise = !!profileData?.vipLevel && profileData.vipLevel > 0;

  // 统计数据状态
  const [stats, setStats] = useState({
    totalLabels: 0,
    pendingLabels: 0,
    publishedLabels: 0,
  });
  const [statsLoading, setStatsLoading] = useState(true);

  // 获取统计数据
  useEffect(() => {
    const fetchStats = async () => {
      try {
        setStatsLoading(true);
        const result = await getUserLabelStats();
        if (result) {
          setStats({
            totalLabels: result.totalLabels || 0,
            pendingLabels: result.pendingLabels || 0,
            publishedLabels: result.publishedLabels || 0,
          });
        }
      } catch (error) {
        console.error('获取统计数据失败:', error);
      } finally {
        setStatsLoading(false);
      }
    };

    fetchStats();
  }, []);

  return (
    <div className="profile-info-v2">
      {/* 卡片分组区域 */}
      <div className="info-cards-grid">
        {/* 基本信息卡片 */}
        <div className="info-card">
          <div className="info-card-header">
            <User size={18} color="#3b82f6" />
            <span>基本信息</span>
          </div>
          <div className="info-card-body">
            <div className="info-row">
              <span className="info-row-label">姓名</span>
              <span className="info-row-value">{profileData.realName || '未设置'}</span>
            </div>
            <div className="info-row">
              <span className="info-row-label">手机</span>
              <span className="info-row-value">{profileData.phone || '未绑定'}</span>
            </div>
            <div className="info-row">
              <span className="info-row-label">账号类型</span>
              <span className="info-row-value">
                <span className={`member-badge ${isEnterprise ? 'enterprise' : 'personal'}`}>
                  {isEnterprise ? '企业会员' : '个人会员'}
                </span>
                {/* 升级按钮暂时隐藏
                {!isEnterprise && (
                  <a
                    className="upgrade-link"
                    onClick={(e) => { e.preventDefault(); onUpgrade && onUpgrade(e); }}
                    href="#"
                  >
                    升级
                  </a>
                )}
                */}
              </span>
            </div>
          </div>
        </div>

        {/* 企业信息卡片 */}
        <div className="info-card">
          <div className="info-card-header">
            <Building2 size={18} color="#3b82f6" />
            <span>企业信息</span>
          </div>
          <div className="info-card-body">
            <div className="info-row">
              <span className="info-row-label">企业名称</span>
              <span className="info-row-value">{profileData.company || '未填写'}</span>
            </div>
            <div className="info-row">
              <span className="info-row-label">职位</span>
              <span className="info-row-value">{profileData.position || '未设置'}</span>
            </div>
            <div className="info-row">
              <span className="info-row-label">企业资质</span>
              <span className="info-row-value">
                {profileData.credentials ? (
                  <a href="#" className="credential-link">查看附件</a>
                ) : (
                  <span className="empty-value">暂无</span>
                )}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* 数据统计区域 */}
      <div className="stats-section">
        <div className="stats-header">
          <span>数据统计</span>
        </div>
        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-number">
              {statsLoading ? '-' : stats.totalLabels}
            </div>
            <div className="stat-label">已创建标签</div>
          </div>
          <div className="stat-card">
            <div className="stat-number pending">
              {statsLoading ? '-' : stats.pendingLabels}
            </div>
            <div className="stat-label">审核中</div>
          </div>
          <div className="stat-card">
            <div className="stat-number success">
              {statsLoading ? '-' : stats.publishedLabels}
            </div>
            <div className="stat-label">已发布</div>
          </div>
        </div>
      </div>
    </div>
  );
}
